<template>
<div class="specialAnalysisMgt">
    <div class="data-total">
        <div class="box">
            <div class="box-detail">
                <div class="box-title">
                    访问次数
                    <el-tooltip content="首页访问次数" placement="top">
                        <div>
                            <i class="tip el-icon-info"></i>
                        </div>
                    </el-tooltip>
                </div>
                <div class="box-data"><span class="data">{{item.viewcount}}</span></div>
            </div>

        </div>
        <div class="box">
            <div class="box-detail">
                <div class="box-title">
                    参与人数
                    <el-tooltip content="参与到题库的试卷" placement="top">
                        <div>
                            <i class="tip el-icon-info"></i>
                        </div>
                    </el-tooltip>
                </div>
                <div class="box-data"><span class="data">{{item.customercount}}</span></div>
            </div>
        </div>
        <div class="box">
            <div class="box-detail">
                <div class="box-title">
                    试卷参与数
                    <el-tooltip content="发起试卷考试的数量" placement="top">
                        <div>
                            <i class="tip el-icon-info"></i>
                        </div>
                    </el-tooltip>
                </div>
                <div class="box-data"><span class="data">{{item.paperjoincount}}</span></div>
            </div>
        </div>
        <div class="box">
            <div class="box-detail">
                <div class="box-title">
                    试卷完成数
                    <el-tooltip content="成功提交试卷的数量" placement="top">
                        <div>
                            <i class="tip el-icon-info"></i>
                        </div>
                    </el-tooltip>
                </div>
                <div class="box-data"><span class="data">{{item.paperfinishcount}}</span></div>
            </div>
        </div>
        <div class="box">
            <div class="box-detail">
                <div class="box-title">
                    试卷完成率
                    <el-tooltip content="完成试卷数/试卷参与数" placement="top">
                        <div>
                            <i class="tip el-icon-info"></i>
                        </div>
                    </el-tooltip>
                </div>
                <div class="box-data"><span class="data">{{item.finishrate}}%</span></div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="filters bgc">
            <div class="add">
                <div class="title">考试参与趋势图</div>
            </div>
            <div class="search">
                <el-button type="text" plain @click="handleQuery(3)" :class="[param.timetype==3?'selected': '']">近7天</el-button>
                <el-button type="text" plain @click="handleQuery(4)" :class="[param.timetype==4?'selected': '']">近30天</el-button>
                <el-date-picker class="dateInput" v-model="timeSlot" type="daterange" align="right" :picker-options="pickerDateFront"
                                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                </el-date-picker>
                <el-button type="primary" @click="handleQuery(0)">确认筛选</el-button>
            </div>
        </div>
        <div>
            <lineReport :lineDatas="lineDatas" class="lineDatas"></lineReport>
        </div>
    </div>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {getQuestionbanktopicinfo, getQuestionbanktopicinfoByexam} from 'api/questionApi'
import LineReport from 'base/echarts/lineReport'
import {dateFormat} from 'common/js/tools'
export default {
    name: 'specialAnalysisMgt',
    data() {
        return {
            item: {
                customercount: '',
                finishrate: '',
                paperfinishcount: '',
                paperjoincount: '',
                viewcount: '',
            },
            lineDatas: {id: 'specialAnalysisMgt', subText: '', xdata: [], data: [], legendAddr: 'left', formatter: '{a0}: {c0}<br />{a1}: {c1}'},
            timeSlot: null,
            param: {
                timetype: 3, // 时间类型 0自定义 1今日 2昨日 3近7日 4近30日
                examcode: this.$route.query.examcode,
                endtime: '',
                begintime: ''
            },
            init: false,
            pickerDateFront: {
                disabledDate(time) {
                    return time.getTime() > Date.now()
                },
                onPick({ maxDate, minDate }) {
                    if (maxDate) {
                        if (maxDate - minDate > 30 * 24 * 60 * 60 * 1000) {
                            this.$message.error('时长不能超过30天，请重新选择')
                        }
                    }
                }
            }
        }
    },
    mounted() {
    },
    methods: {
        initData() {
            if (!this.init) this._getTotal()
        },
        handleQuery(index) {
            if (!index) {
                if (this.timeSlot) {
                    let beginDate = new Date(this.timeSlot[0])
                    let endDate = new Date(this.timeSlot[1])
                    if (endDate- beginDate > 30 * 24 * 60 * 60 * 1000) {
                        this.$message.error('时长不能超过30天，请重新选择')
                        return false
                    }
                    this.param.begintime = this.timeSlot[0]
                    this.param.endtime = this.timeSlot[1]
                } else {
                    this.param.begintime = ''
                    this.param.endtime = ''
                }
            } else {
                let endtime = new Date()
                let begintime = null
                if (index == 3) {
                    begintime = new Date(endtime.getTime() - 7 * 24 * 60 * 60 * 1000)
                } else if (index == 4) {
                    begintime = new Date(endtime.getTime() - 30 * 24 * 60 * 60 * 1000)
                }
                let Eyear = endtime.getFullYear()
                let Emouth = (endtime.getMonth() + 1) < 10 ? '0' + (endtime.getMonth() + 1) : (endtime.getMonth() + 1)
                let Eday = endtime.getDate() < 10 ? '0' + endtime.getDate() : endtime.getDate()
                this.param.endtime = Eyear + '-' + Emouth + '-' + Eday
                let Byear = begintime.getFullYear()
                let Bmouth = (begintime.getMonth() + 1) < 10 ? '0' + (begintime.getMonth() + 1) : (begintime.getMonth() + 1)
                let Bday = begintime.getDate() < 10 ? '0' + begintime.getDate() : begintime.getDate()
                this.param.begintime = Byear + '-' + Bmouth + '-' + Bday
            }
            this.param.timetype = index
            this._getLineData()
        },
        _getTotal() {
            this.setLoading(true)
            getQuestionbanktopicinfo({
                data: Object.assign({}, this.param),
                success: data => {
                    this.item = data.data
                    this.init = true
                    this.setLoading(false)
                    this.handleQuery(3)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getLineData() {
            this.setLoading(true)
            getQuestionbanktopicinfoByexam({
                data: Object.assign({}, this.param),
                success: data => {
                    let xdata = data.data.xdate
                    let [ydata1, ydata2] = [data.data.customercountlist, data.data.paperfinishcountlist]
                    this.lineDatas.xdata = xdata
                    this.lineDatas.data=[]
                    this.lineDatas.data.push(
                        {
                            title: '试卷参与数',
                            color: '#1989FA',
                            smooth: true,
                            symbol: 'circle',
                            list: ydata1
                        },
                        {
                            title: '试卷完成数',
                            color: '#67C23A',
                            smooth: true,
                            symbol: 'circle',
                            list: ydata2
                        }
                    )
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        LineReport
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.specialAnalysisMgt {
    .data-total {
        margin-top: 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #F5F7FA;
        padding: 24px 0;
        .box {
            align-items: center;
            display: flex;
            padding: 0 30px;
            height: 80px;
            width: 250px;
            box-sizing: border-box;
            flex-grow: 1;
            position: relative;
            .box-detail {
                flex-grow: 1;
            }
            .el-tooltip {
                /*position: absolute;*/
                width: 14px;
                height: 14px;
                top: 10px;
                right: 10px;
                margin-left: 10px;
            }
            .box-data{
                margin-top: 20px;
                font-size: 36px;
            }
            .box-title{
                display: flex;
                align-items: center;
            }
            .tip{
                color: #999999;
            }
        }
        .box + .box {
            border-left: 2px solid #DCDFE6;
        }
        .box:nth-child(1) {
        }
    }
    .container{
        margin-top: 30px;
        .title{
            border-left: 2px solid #409EFF;
            padding: 0 12px;
            color: #303133;
            font-size: 16px;
        }
        .el-button--text{
            width: auto;
            min-width: auto;
            color: #303133;
            margin: 0 20px;
        }
        .el-button{
            margin-left: 20px;
        }
        .el-button.is-plain:focus, .el-button.is-plain:hover{
            border-color: transparent;
            color: #409EFF;
        }
        .el-button--text.selected{
            color: #409EFF;
        }
    }
}
</style>
